import { includes } from 'lodash'

export default {
    computed: {
        isZDAUrl() {
            return includes(window.location.href, 'zdaspb.rzd')
        }
    }
}